import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _Entailment, _single } from "../../../core/services/dataBean/EntityCatalog";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { SelectTypeProcees } from "../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { _SignAndApprovalPanel } from "../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../theme/Component/BasicButton";
import { Verfirmas } from "./Verfirmas";
import { SimularfirmasFlujo } from "./SimularfirmasFlujo";
import { RequisitosFirma } from "./RequisitosFirma";


export const SignAndApprovalPanel = () => {

    const { instance, setBean, bean, lista, setLista, handleChange } = useDataBean(_SignAndApprovalPanel);
    const updatesing = useDataBean(_SignAndApprovalPanel);
    const [processType, setProcessType] = useState<any>(null);

    const [obs, setObs] = useState<string>("");

    const [simularfirmas, setSimularfirmas] = useState<any>({ name: 'Firmas', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [verfirmas, setVerfirmas] = useState<any>({ name: 'Firmas', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [requisitos, setRequisitos] = useState<any>({ name: 'Firmas', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        // getLista();
    }, [])

    const getLista = () => {

        instance.getSignAndApprovalPanelCatalog(processType).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        setBean({
            ProcessType: bean.ProcessType,
            IDEmployee: _single.getAccountID
        });
        setModal({ ...modal, "view": true });
    }

    const deleteItem = () => {
        instance.deleteSignAndApprovalPanel(bean.IDSignAndApprovalPanel, _single.getAccountID(), obs).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
                setObs("")
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        instance.updateSignAndApprovalPanel(bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDSignAndApprovalPanel', visible: true },
        { title: 'Código del Flujo', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Propiedades Json Gestor Documental', property: 'JsonCode', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: true },
        { title: 'Desde', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Requisitos panel de firma', icono: 'ri-file-user-line', visible: true, evento: () => { setRequisitos({ ...requisitos, "name": `${bean.Name} `, "view": true }) } },
            { titulo: 'Ver Firmas', icono: 'ri-file-user-line', visible: true, evento: () => { setVerfirmas({ ...verfirmas, "name": `${bean.Name} `, "view": true }) } },
            { titulo: 'Simular Flujo de Firma', icono: 'ri-file-user-line', visible: true, evento: () => { setSimularfirmas({ ...simularfirmas, "name": `${bean.Name} `, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Flujos de Aprobación y Firma de Documentos y Procesos">
            <div className="row">
                <div className="col-md-6">
                    <SelectTypeProcees label="Tipo de Proceso" idSelector={processType} onChange={(e) => setProcessType(e)} />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={bean.Name} onChange={handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={bean.Code} onChange={handleChange} />
                            </div>
                            <div className="col-md-12">
                                <SelectTypeProcees label='Tipo de Proceso' idSelector={bean.ProcessType} onChange={(e: any) => { setBean({ ...bean, "ProcessType": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Propiedades Json Gestor Documental</label>
                                <textarea name="JsonCode" className="form-control" value={bean.JsonCode} onChange={handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <strong>Eliminar item {bean.Name}</strong>
                            </div>
                            <div className="col-md-12">
                                <label >Observaciones</label>
                                <textarea className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
                            </div>
                        </div>
                    </ModalConfirm>
                    <Modal modal={verfirmas} updateModal={setVerfirmas} >
                        {/* <Verfirmas IDMacroProcess={signAndApprovalPanel.bean.IDSignAndApprovalPanel} /> */}
                        <>
                            <Verfirmas IDSignAndApprovalPanel={bean.IDSignAndApprovalPanel} />
                        </>
                    </Modal>
                    <Modal modal={requisitos} updateModal={setRequisitos} >

                        <>
                            <RequisitosFirma IDSignAndApprovalPanel={bean.IDSignAndApprovalPanel} />
                        </>
                    </Modal>
                    <Modal modal={simularfirmas} updateModal={setSimularfirmas} >
                        {/* <Verfirmas IDMacroProcess={signAndApprovalPanel.bean.IDSignAndApprovalPanel} /> */}
                        <>
                            <SimularfirmasFlujo IDSignAndApprovalPanel={bean.IDSignAndApprovalPanel} />
                        </>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}